import api from './index'

class SummaryService {
	getSummary(params) {
		return api.get('/summary', { params })
	}
	getDepositSummary(params) {
		return api.get('/summary/deposit', { params })
	}
	getWithdrawSummary(params) {
		return api.get('/summary/withdraw', { params })
	}
	getRegisterSummary(params) {
		return api.get('/summary/register', { params })
	}

	summaryBonus(params) {
		return api.get('/summary/bonus', { params })
	}

	summaryWheel(params) {
		return api.get('/summary/wheel', { params })
	}

	summaryCashback(params) {
		return api.get('/summary/cashback', { params })
	}

	summaryReportByMember(params) {
		return api.get('/summary/report-by-member', { params })
	}
}

export default new SummaryService()
